/** @jsx jsx */
import { jsx, BaseStyles } from "theme-ui";
import { Themed } from "@theme-ui/mdx";
import { Link as GatsbyLink } from "gatsby";

import FluidImage from "../components/FluidImage";

export const BlogPostExtractL = ({slug, image, alt, title, author, date, excerpt}) => {
  return (
    <article sx={{mb: 8}}>

      <header>
        <FluidImage image={image} alt={alt} />
        <Themed.h1 sx={{mt: 3, mb: 1}}>
          <GatsbyLink
            to={slug}
            sx={{
              variant: "links.inline",
              color: "textDark.1"
            }}
          >
            {title}
          </GatsbyLink>
        </Themed.h1>
        <div sx={{mb: 5}}>
          {`By ${author} on ${date}`}
        </div>
      </header>

      {/* BaseStyles needed to apply theme.styles to non-MDX markdown */}
      <BaseStyles>
        <section sx={{mb: 5}} dangerouslySetInnerHTML={{ __html: excerpt }} />
      </BaseStyles>

      <div sx={{textAlign: "center"}}>
        <GatsbyLink
          to={slug}
          sx={{
            variant: "buttons.small",
          }}
        >
          Read full post
        </GatsbyLink>
      </div>

    </article>
  );

};

export const BlogPostExtractS = ({slug, image, alt, title, excerpt, className}) => {
  return (
    <article className={className} sx={{mb: 3}}>

      <header>
        <FluidImage image={image} alt={alt} />
        <Themed.h3 sx={{mt: [3, 3, 4]}}>
          <GatsbyLink
            to={slug}
            sx={{
              variant: "links.inline",
              color: "textDark.1"
            }}
          >
            {title}
          </GatsbyLink>
        </Themed.h3>
      </header>

      {/* BaseStyles needed to apply theme.styles to non-MDX markdown */}
      <BaseStyles>
        <section 
          sx={{
            display: "-webkit-box",
            WebkitLineClamp: "3", 
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            // Necessary for Safari to display exactly 3 lines. Relies on
            // font size being 1rem and line height 1.4rem.
            height: "4.2rem" 
          }} 
          dangerouslySetInnerHTML={{ __html: excerpt }} />
      </BaseStyles>

    </article>
  );

};
